import { useRef } from 'react';
import {
  CourseStatusTooltip,
  OptionalCourseStatusTooltip,
} from '../../views/CurriculumProgressStudent/types/progress';
import CoursesBySemester from './parts/CoursesBySemester';
import { CoursesBySemestersExtraCourse, SemesterCourse } from './types';
import { getColor as getColorCore } from './utils';
import {
  CourseEnrollmentStates,
  CourseValidationType,
} from '../../types/CourseValidationType';
import ModalCreateValidation, {
  ModalCreateValidationMethods,
} from '../../views/CourseValidationInternalStudent/parts/ModalCreateValidation';

export type Semester = {
  id: number | string;
  title?: string;
  semesterIndex: number;
  semesterCourses: SemesterCourse[];
};

export interface CoursesBySemestersProps {
  extraCourses?: CoursesBySemestersExtraCourse[];
  semesters: Semester[];
  texts: {
    credits: string;
    optionalToolTip: (data: OptionalCourseStatusTooltip) => string;
    convalidationToolTip: (data: CourseStatusTooltip) => string;
    equivalentToTooltip?: (data: { code: string; name: string }) => string;
    degreeActivityType?: string;
    degreeActivityTooltip?: string;
  };
  getColor?: (
    state?: CourseEnrollmentStates | CourseValidationType,
  ) => string | undefined;
  onClick?: (semesterCourse: SemesterCourse) => void;
}

export default function CoursesBySemesters({
  extraCourses,
  semesters,
  texts,
  onClick,
  getColor = getColorCore,
}: CoursesBySemestersProps) {
  const createValidationRef = useRef<ModalCreateValidationMethods>(null);

  const onClickShow = (row: SemesterCourse) => {
    createValidationRef?.current?.openSemesterCourse({
      semesterCourse: row,
      readonly: true,
      studyPlanEnrollmentId: 0,
    });
  };

  return (
    <>
      <div
        className="g-progression d-flex w-100"
        style={{
          overflowX: 'auto',
          flexDirection: 'row',
          gap: 16,
          marginLeft: -16,
          marginRight: -16,
          paddingBottom: 16,
          paddingRight: 16,
          paddingLeft: 16,
        }}
      >
        {semesters.map((semester, index) => {
          return (
            <CoursesBySemester
              key={semester.id}
              {...semester}
              getColor={getColor}
              title={
                semester.title ? semester.title : `${semester.semesterIndex}`
              }
              texts={texts}
              onClick={onClick}
              onClickInfoModal={onClickShow}
              extraCourses={
                semesters.length - 1 === index ? extraCourses : undefined
              }
            />
          );
        })}
      </div>
      <ModalCreateValidation ref={createValidationRef} />
    </>
  );
}
